import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getAll(params = {}) {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${API_URL}/groups?${query}` : `${API_URL}/groups`;
        return axios.get(url, { headers: authHeader() });
    },
    getData(id) {
        return axios.get(`${API_URL}/groups/${id}`, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/groups`, data, { headers: authHeader() });
    },
    updateData(id, data) {
        return axios.put(`${API_URL}/groups/${id}`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/groups/${id}`, { headers: authHeader() });
    },
    getAvailableUsers(params = {}) {
        const query = new URLSearchParams(params).toString();
        const url = query ? `${API_URL}/groups/available-users?${query}` : `${API_URL}/groups/available-users`;
        return axios.get(url, { headers: authHeader() });
    },
};
